import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import ir.site.zero1plus.pages.HomePage as _ir_site_zero1plus_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Zero1plus"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _ir_site_zero1plus_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("my-card-p", ir.site.zero1plus.components.sections.MyCardPStyle)
        ctx.theme.registerStyle("my-heading", ir.site.zero1plus.components.sections.MyHeadingStyle)
        ctx.theme.registerStyle("footer", ir.site.zero1plus.components.sections.FooterStyle)
        ctx.theme.registerStyle("footer-link", ir.site.zero1plus.components.sections.FooterLinkStyle)
        ctx.theme.registerStyle("social-link", ir.site.zero1plus.components.sections.SocialLinkStyle)
        ctx.theme.registerStyle("social-link-item", ir.site.zero1plus.components.sections.SocialLinkItemStyle)
        ctx.theme.registerStyle("my-input", ir.site.zero1plus.components.sections.MyInputStyle)
        ctx.theme.registerStyle("nav-header", ir.site.zero1plus.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("logo-brand", ir.site.zero1plus.components.sections.LogoBrandStyle)
        ctx.theme.registerStyle("nav-bar-item", ir.site.zero1plus.components.sections.NavBarItemStyle)
        ctx.theme.registerStyle("hero-image", ir.site.zero1plus.components.sections.HeroImageStyle)
        ctx.theme.registerStyle("my-paragraph", ir.site.zero1plus.components.style.MyParagraphStyle)
        ctx.theme.registerStyle("card", ir.site.zero1plus.components.widgets.CardStyle)
        ctx.theme.registerStyle("over-flow-menu", ir.site.zero1plus.components.widgets.OverFlowMenuStyle)
        ctx.theme.registerStyle("over-flow-menu-items", ir.site.zero1plus.components.widgets.OverFlowMenuItemsStyle)
        ctx.theme.registerStyle("primary-button", ir.site.zero1plus.components.widgets.PrimaryButtonStyle)
        ctx.theme.registerStyle("section-heading", ir.site.zero1plus.components.widgets.SectionHeadingStyle)
        ctx.theme.registerStyle("theme-button", ir.site.zero1plus.components.widgets.ThemeButtonStyle)
        ctx.theme.registerVariant("-primary-button-normal", ir.site.zero1plus.components.widgets.PrimaryButtonNormalVariant
        )
        ctx.theme.registerVariant("-primary-button-outlined", ir.site.zero1plus.components.widgets.PrimaryButtonOutlinedVariant
        )
        ir.site.zero1plus.theme.overrideSilkTheme(ctx)
        ir.site.zero1plus.initStyles(ctx)
        com.stevdza.san.kotlinbs.initBuildScriptLayers(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        ir.site.zero1plus.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
